// Select all <details> elements
const allDetails = document
  .querySelector(".header-custom-menu")
  .querySelectorAll("details");

// Loop through each <details> element
allDetails.forEach((details) => {
  let submenu = details.querySelector("div:not(summary)");
  let checkHoverInterval;

  // Add an event listener to open the <details> on mouse enter
  details.addEventListener("mouseenter", () => {
    allDetails.forEach((details) => {
      details.removeAttribute("open");
    });
    details.setAttribute("open", "");
  });

  details.addEventListener("mouseleave", () => {
    if (checkHoverInterval) return;

    checkHoverInterval = setInterval(() => {
      // Check if the cursor is over the submenu
      if (!submenu.matches(":hover")) {
        console.log("Cursor is not hovering over the submenu. Closing...");
        details.open = false; // Close the submenu
        clearInterval(checkHoverInterval); // Stop checking
        checkHoverInterval = null; // Clean up reference
      } else {
        console.log("Cursor is still hovering over the submenu.");
      }
    }, 200);
  });

  // // Add an event listener to close the <details> on mouse leave
  // submenu.addEventListener("mouseleave", () => {
  //   details.removeAttribute("open");
  // });

  // Stop checking when mouse re-enters the details element
  details.addEventListener("mouseover", () => {
    clearInterval(checkHoverInterval);
    checkHoverInterval = null;
  });

  // Stop checking if the cursor is hovering over the dropdown
  submenu.addEventListener("mouseover", () => {
    clearInterval(checkHoverInterval);
    checkHoverInterval = null;
  });

  // Prevent default toggle behavior when clicking on <summary>
  const summary = details.querySelector("summary");
  if (summary) {
    summary.addEventListener("click", (event) => {
      event.preventDefault();
    });
  }
});
